import script from "./cancelProgramModal.vue?vue&type=script&setup=true&lang=js"
export * from "./cancelProgramModal.vue?vue&type=script&setup=true&lang=js"

import "./cancelProgramModal.vue?vue&type=style&index=0&id=02460ed0&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02460ed0"]])

export default __exports__